<ng-container *ngIf="platforms.length !== allPlatforms.length">
  <span
    *ngFor="let platform of platforms"
    [ngClass]="platform"
    [attr.data-testid]="'platform-item-' + platform"
  >
    {{ platform }}
  </span>
</ng-container>
